import { useEffect, useState } from "react";
import { Breadcrumb, Button, FloatingLabel, Form, Modal } from "react-bootstrap";
import LoadingComponent from "../../../widgets/LoadingComponent";
import { FaPencil, FaPlus } from "react-icons/fa6";
import { getData, postData } from "../../../api/ApiRest";
import { FaCheckCircle, FaRegTimesCircle, FaSave, FaSearch } from "react-icons/fa";

function Producto() {
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState({
        ModalVisible: false, Titulo: '', Accion: false
    });

    const [infoProducto, setInfoProducto] = useState({});
    const [dataBuscar, setDataBuscar] = useState({});

    const [arrayProductos, setArrayProductos] = useState([]);

    const [arrayPlans, setArrayPlans] = useState([]);

    useEffect(() => {
        visualizarPlanes();
    }, []);

    const visualizarPlanes = () => {
        setLoading(true);

        getData('api/Configuracion/UtilityPublic/getPlanesActuales').then(response => {
            setArrayPlans(response.plans);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    ///Función para crear productos
    const crearProducto = () => {
        setLoading(true);

        postData('api/Configuracion/UtilityPublic/gestionProducto', {
            accion: modalVisible.Accion
        }, infoProducto).then(response => {
            if (response.status) {
                alert(response.msj);

                setModalVisible({
                    ModalVisible: false, Accion: false, Titulo: ''
                });
            } else
                alert(response.msj);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    //Función para buscar una serie de productos
    const buscarProductos = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Configuracion/UtilityPublic/getDataProductos', {
            codigo: dataBuscar.Codigo || '',
            referencia: dataBuscar.Referencia || '',
            descripcion: dataBuscar.Descripcion || ''
        }).then(response => {
            console.log('Productos: ', response);
            setArrayProductos(response.productos);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item >Home</Breadcrumb.Item>
            <Breadcrumb.Item active={true}>Productos</Breadcrumb.Item>
        </Breadcrumb>

        <Button variant='success' size="sm" onClick={() => {
            setModalVisible({ ModalVisible: true, Titulo: 'Nuevo producto', Accion: false });
        }}
            className='mb-2'>
            <FaPlus size={'0.8rem'} />
        </Button>

        {<LoadingComponent Loading={loading} />}

        <Form onSubmit={buscarProductos}>
            <div className='row'>
                <div className='col-md-3'>
                    <FloatingLabel
                        controlId="Codigo"
                        label="Código"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="text"
                            autoComplete='off'
                            placeholder="Código"
                            value={dataBuscar.Codigo}
                            onChange={value => setDataBuscar({ ...dataBuscar, Codigo: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-3'>
                    <FloatingLabel
                        controlId="Referencia"
                        label="Referencia"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="text"
                            autoComplete='off'
                            placeholder="Referencia"
                            value={dataBuscar.Referencia}
                            onChange={value => setDataBuscar({ ...dataBuscar, Referencia: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-5'>
                    <FloatingLabel
                        controlId='Descripcion'
                        label="Descripción"
                        className="form-floating-sm"
                    >
                        <Form.Control
                            size='sm'
                            type="text"
                            placeholder="Descripción"
                            value={dataBuscar.Descripcion}
                            onChange={value => setDataBuscar({ ...dataBuscar, Descripcion: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-1'>
                    <Button variant='primary' type='submit' size="sm">
                        <FaSearch size={'0.8rem'} />
                    </Button>
                </div>

            </div>
        </Form>

        <div className="row">
            <div className='table-responsive mt-2'>
                <table className='table table-borderless table-hover'>
                    <thead>
                        <tr>
                            <th className="estilo-encabezado"></th>
                            <th className="estilo-encabezado">#</th>
                            <th className="estilo-encabezado">
                                Código
                            </th>
                            <th className="estilo-encabezado">
                                Referencia
                            </th>
                            <th className="estilo-encabezado">
                                Producto
                            </th>
                            <th className="estilo-encabezado">
                                Activo
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {arrayProductos.map((item, index) => (
                            <tr key={index}>
                                <td style={{ textAlign: 'center' }}>
                                    <Button variant="primary" type="button" title="Editar producto" onClick={() => {
                                        setInfoProducto({
                                            Codigo: item.codigo,
                                            Referencia: item.referencia,
                                            Descripcion: item.descripcion,
                                            Precio: item.precio,
                                            Activo: item.activo,
                                            Impuesto_porc: item.impuesto_porc,
                                            CodigoAnterior: item.codigo,
                                            Planid: item.planid
                                        });

                                        setModalVisible({
                                            Accion: true,
                                            ModalVisible: true,
                                            Titulo: 'Editar producto: ' + item.codigo
                                        });
                                    }}
                                        style={{
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            fontSize: 12
                                        }}>
                                        <FaPencil />
                                    </Button>
                                </td>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td style={{ textAlign: 'center' }}>{item.codigo}</td>
                                <td style={{ textAlign: 'center' }}>{item.referencia}</td>
                                <td style={{ textAlign: 'center' }}>{item.descripcion}</td>
                                <td style={{ textAlign: 'center' }}>{item.activo ? <FaCheckCircle /> : <FaRegTimesCircle />}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>

        <Modal
            show={modalVisible.ModalVisible}
            size="lg"
            onHide={() => {
                setModalVisible({
                    ModalVisible: false, Titulo: '', Accion: false
                });

                setInfoProducto({});
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalVisible.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-3">
                        <FloatingLabel controlId="codigoNewInput" label="Código">
                            <Form.Control
                                as="input"
                                type="text"
                                value={infoProducto.Codigo}
                                onChange={event => setInfoProducto({ ...infoProducto, Codigo: event.target.value })}
                                required
                                autoComplete="off"
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-3">
                        <FloatingLabel controlId="referenciaNewInput" label="Referencia">
                            <Form.Control
                                as="input"
                                type="text"
                                value={infoProducto.Referencia}
                                onChange={event => setInfoProducto({ ...infoProducto, Referencia: event.target.value })}
                                required
                                autoComplete="off"
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-6">
                        <FloatingLabel controlId="descripcionNewInput" label="Descripción">
                            <Form.Control
                                as="input"
                                type="text"
                                value={infoProducto.Descripcion}
                                onChange={event => setInfoProducto({ ...infoProducto, Descripcion: event.target.value })}
                                required
                                autoComplete="off"
                            />
                        </FloatingLabel>
                    </div>
                </div>
                <div className="row" style={{ marginTop: 10 }}>
                    <div className="col-md-3">
                        <FloatingLabel controlId="precioNewInput" label="Precio">
                            <Form.Control
                                as="input"
                                type="number"
                                value={infoProducto.Precio}
                                onChange={event => setInfoProducto({ ...infoProducto, Precio: event.target.value })}
                                min={0}
                                required
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-3">
                        <FloatingLabel controlId="precioNewInput" label="Impuesto %">
                            <Form.Control
                                as="input"
                                type="number"
                                value={infoProducto.Impuesto_porc}
                                onChange={event => setInfoProducto({ ...infoProducto, Impuesto_porc: event.target.value })}
                                min={0}
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-3">
                        <FloatingLabel
                            controlId='plan'
                            label="Plan"
                            className="mb-2"
                        >
                            <Form.Select
                                value={infoProducto.Planid}
                                onChange={event => {
                                    setInfoProducto({ ...infoProducto, Planid: event.target.value });
                                }}
                            >
                                <option value="">Seleccione</option>
                                {arrayPlans.map((item, index) =>
                                    <option key={index} value={item.planid}>{item.descripcion}</option>
                                )}
                            </Form.Select>
                        </FloatingLabel>
                    </div>
                    <div className='col-md-1'>
                        <label>Activo</label>
                        <Form.Check
                            style={{
                                textAlign: 'center'
                            }}
                            required
                            checked={infoProducto.Activo}
                            onChange={event => setInfoProducto({ ...infoProducto, Activo: event.target.checked })}
                        />
                    </div>
                    <div className="col-md-1">
                        <Button variant="success" type="button" onClick={() => crearProducto()}>
                            <FaSave size={'1rem'} />
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>

    </div>
}

export default Producto;